import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format number according to Vietnamese locale
 * Examples:
 * - 45678.5 → "45,678.5"
 * - 1234567.89 → "1,234,567.89"
 * - 0 → "0"
 * - 0.1 → "0.1"
 */
export function formatNumber(value: number, decimals?: number): string {
  if (value === 0) return '0';
  
  // Use Vietnamese locale (vi-VN) for formatting
  // This will use comma for thousands separator and dot for decimal separator
  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals ?? 2,
  };
  
  return new Intl.NumberFormat('vi-VN', options).format(value);
}

/**
 * Format number with specific decimal places for display
 * Common use cases:
 * - formatNumberDisplay(1234.567, 1) → "1,234.6" (containers)
 * - formatNumberDisplay(1234.567, 2) → "1,234.57" (M3, Kg)
 * - formatNumberDisplay(1234, 0) → "1,234" (labor count)
 */
export function formatNumberDisplay(value: number, decimals: number = 2): string {
  if (value === 0) return '0';
  if (value < 0.01 && decimals === 1) return '0.0'; // For container count
  if (value < 0.01) return '0'; // For very small values
  
  return formatNumber(value, decimals);
}
